/* eslint-disable @typescript-eslint/no-explicit-any */
import "react-toastify/dist/ReactToastify.css";
import qs from "qs";
import { api } from "../api/httpClient";
import { IListParams } from "@/interfaces/serviceInterface";
import { BASE_URL } from "../api/config";

const BASE_REPORTS = "/reports";

export async function listParamsReport({ report }: { report: string }) {
  const { data } = await api.get<any>(`${BASE_REPORTS}/${report}/params`);
  return data;
}

export function downloadReport({ report }: { report: string }) {
  const url = `${BASE_URL}${BASE_REPORTS}/${report}/download`;
  window.open(url, "_blank");
}

export async function executeReport({ report, idResponse }: { report: string, idResponse: number }) {
  const response = await api.get(`${BASE_REPORTS}/${report}/${idResponse}/execute?id=${idResponse}`, {
    responseType: 'blob'
  });
  return response.data;
}


export async function exportsXlsx({
  filter,
  includes,
  page,
  limit,
}: IListParams) {
  const params = qs.stringify({ filter, includes, page, limit });
  const endPoint = `${BASE_URL}/activities/export/xlsx?${params}`;
  return window.open(endPoint);
}

export async function exportsXlsxCustom({ filter, config }: { filter: any, config: any }) {
  const response = await api.post(`/activities/export/xlsx`,
    { filter, config },
    { responseType: 'blob' }
  );

  const url = window.URL.createObjectURL(new Blob([response.data]));
  const link = document.createElement('a');
  link.href = url;
  // Usa o nome definido no modal ou um padrão
  link.setAttribute('download', `${config.fileName || 'atividades'}.xlsx`);
  document.body.appendChild(link);
  link.click();
  link.remove();
}